module.exports = __webpack_public_path__ + "img/home-landing-add-patient.6f6814c8.svg";